import { Injectable } from '@angular/core';
import { CanActivate, Router } from '@angular/router';
import { map, Observable } from 'rxjs';
import { ConfigService } from '../../services/config/config.service';
import { ThemeService } from '../../services/theme/theme.service';

/**
 * Blocks non-betting routes (auth, promotions, account/profile) whenever
 * the platform is restricted to betting-only pages - either because the
 * active theme is a virtual/embedded one (Theme.isVirtual) or because a
 * partner-operation session is active (ConfigService.partnerOperation.
 * enabled). This is the same "isVirtual || partnerOperation.enabled" check
 * already duplicated in app.ts/header.ts/sidebar.ts/betslip.ts/
 * home.component.ts, applied here at the route level instead. Supersedes
 * PartnerOperationGuard (enabled-only) on the `user` route - this covers
 * that same case plus a virtual theme with no partner query params.
 */
@Injectable({
  providedIn: 'root'
})
export class BettingOnlyGuard implements CanActivate {

  constructor(
    private readonly configService: ConfigService,
    private readonly themeService: ThemeService,
    private readonly router: Router
  ) {}

  canActivate(): Observable<boolean> {

    return this.configService.partnerOperation$.pipe(
      map(partnerOperation => {

        const isRestricted =
          partnerOperation.enabled ||
          this.themeService.getTheme().isVirtual;

        if (isRestricted) {
          this.router.navigateByUrl('/');
        }

        return !isRestricted;
      })
    );
  }
}
